import * as React from "react";
const LogoIcon = (props) => {
  return (
    <svg
      id="eYBXig1fbcm1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 224.87 224.87"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      project-id="836baf3236054617b8dd75b091e45d7e"
      export-id="6ede2f5242164e0b89027d8decd18ad8"
      cached="false"
    >
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n#eYBXig1fbcm4_tr {animation: eYBXig1fbcm4_tr__tr 3000ms linear infinite normal forwards}@keyframes eYBXig1fbcm4_tr__tr { 0% {transform: translate(112.439338px,112.440403px) rotate(0deg)} 100% {transform: translate(112.439338px,112.440403px) rotate(720deg)}} #eYBXig1fbcm17_ts {animation: eYBXig1fbcm17_ts__ts 3000ms linear infinite normal forwards}@keyframes eYBXig1fbcm17_ts__ts { 0% {transform: translate(77.970001px,42.190001px) scale(0.75,0.75)} 25% {transform: translate(77.970001px,42.190001px) scale(1,1)} 50% {transform: translate(77.970001px,42.190001px) scale(0.75,0.75)} 75% {transform: translate(77.970001px,42.190001px) scale(1,1)} 100% {transform: translate(77.970001px,42.190001px) scale(0.75,0.75)}} #eYBXig1fbcm18_ts {animation: eYBXig1fbcm18_ts__ts 3000ms linear infinite normal forwards}@keyframes eYBXig1fbcm18_ts__ts { 0% {transform: translate(180.5px,143.169983px) scale(1,1)} 25% {transform: translate(180.5px,143.169983px) scale(0.75,0.75)} 50% {transform: translate(180.5px,143.169983px) scale(1,1)} 75% {transform: translate(180.5px,143.169983px) scale(0.75,0.75)} 100% {transform: translate(180.5px,143.169983px) scale(1,1)}}\n",
        }}
      />
      <defs>
        <linearGradient
          id="eYBXig1fbcm4-fill"
          x1="-12.08983"
          y1="124.942334"
          x2="240.700922"
          y2="99.54305"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="eYBXig1fbcm4-fill-0" offset="0%" stopColor="#f77d27" />
          <stop id="eYBXig1fbcm4-fill-1" offset="100%" stopColor="#ab03ff" />
        </linearGradient>
        <linearGradient
          id="eYBXig1fbcm6-fill"
          x1="-9.982651"
          y1="189.444634"
          x2="181.169584"
          y2="157.377332"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="eYBXig1fbcm6-fill-0" offset="0%" stopColor="#f77d27" />
          <stop id="eYBXig1fbcm6-fill-1" offset="100%" stopColor="#ab03ff" />
        </linearGradient>
        <linearGradient
          id="eYBXig1fbcm9-fill"
          x1="-26.995646"
          y1="145.420152"
          x2="188.898263"
          y2="26.18777"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="eYBXig1fbcm9-fill-0" offset="0%" stopColor="#f77d27" />
          <stop id="eYBXig1fbcm9-fill-1" offset="100%" stopColor="#ab03ff" />
        </linearGradient>
        <linearGradient
          id="eYBXig1fbcm11-fill"
          x1="-10.03922"
          y1="135.09639"
          x2="182.781788"
          y2="143.008917"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="eYBXig1fbcm11-fill-0" offset="0%" stopColor="#f77d27" />
          <stop id="eYBXig1fbcm11-fill-1" offset="100%" stopColor="#ab03ff" />
        </linearGradient>
        <linearGradient
          id="eYBXig1fbcm16-fill"
          x1="-167.708294"
          y1="16.856187"
          x2="85.082458"
          y2="-8.543097"
          spreadMethod="pad"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 0)"
        >
          <stop id="eYBXig1fbcm16-fill-0" offset="0%" stopColor="#f77d27" />
          <stop id="eYBXig1fbcm16-fill-1" offset="100%" stopColor="#ab03ff" />
        </linearGradient>
      </defs>
      <g style={{ isolation: "isolate" }}>
        <g>
          <g
            id="eYBXig1fbcm4_tr"
            transform="translate(112.439338,112.440403) rotate(0)"
          >
            <path
              d="M163.92,212.41c1.31-.67,2.6-1.37,3.89-2.1c1.2-.68,2.38-1.38,3.56-2.1.63-.39,1.26-.79,1.89-1.19c4.01-2.58,7.89-5.45,11.62-8.59c2.42-2.04,4.78-4.2,7.06-6.48c1.54-1.54,3.01-3.11,4.44-4.71.92-1.03,1.81-2.07,2.68-3.12c3.13-3.77,5.98-7.7,8.54-11.76.15-.24.31-.48.46-.73c26.9-43.37,21.53-101.06-16.11-138.7-37.6-37.59-95.17-42.99-138.52-16.23-1.38.85-2.74,1.74-4.09,2.65-2.23,1.52-4.42,3.12-6.56,4.82-3.41,2.7-6.7,5.61-9.85,8.76-8.92,8.92-16.03,18.96-21.32,29.68-1.22,2.47-2.35,4.98-3.38,7.52-.69,1.69-1.33,3.4-1.93,5.11-.9,2.58-1.7,5.18-2.41,7.8-7.42,27.5-4.22,57.25,9.58,82.8.4.74.8,1.47,1.22,2.2.58,1.01,1.17,2.02,1.78,3.01.67,1.09,1.35,2.18,2.06,3.25c2.57,3.9,5.41,7.67,8.52,11.29c1.87,2.17,3.83,4.29,5.89,6.35s4.18,4.02,6.35,5.89c3.33,2.86,6.79,5.48,10.35,7.89c1.56,1.05,3.14,2.06,4.74,3.03.65.39,1.3.78,1.96,1.16.9.52,1.8,1.02,2.7,1.51c32.59,17.6,72.04,17.94,104.89,1.01l-.01-.02Z"
              transform="translate(-112.439338,-112.440403)"
              fill="url(#eYBXig1fbcm4-fill)"
            />
          </g>
          <path
            style={{ mixBlendMode: "multiply" }}
            d="M191.94,191.94c.27-.27.53-.54.79-.81-11.74-7.91-27.73-6.81-38.3,3.29-.78-1.15-1.67-2.24-2.69-3.26-5.18-5.18-12.29-7.25-19.02-6.23-.14-5.48-2.29-10.92-6.47-15.1-6.47-6.47-15.94-8.09-23.92-4.89.31-14.08,4.5-28.34,11.14-40.94c1.14-2.16-1.78-9.94-.47-11.94L33.02,192.04c15.05,15.01,33.29,24.88,52.53,29.6c7.48,1.09,14.92,2.15,21.99,3.13c30.38,1.31,61.2-9.62,84.4-32.82v-.01Z"
            opacity="0.2"
          />
          <path
            d="M133.24,192.64c-6.31-6.31-15.71-7.62-23.31-3.96-.61-4.21-2.53-8.26-5.77-11.49-3.57-3.57-8.12-5.53-12.78-5.91c2.28-19.33,12.64-39.28,26.99-54.71-4.99-3.75-4.43-5.45-4.43-5.45L33.03,192.03c30.15,30.08,73.13,39.5,111.3,28.25-2.14-1.94-4.59-3.35-7.18-4.23c3.72-7.62,2.42-17.07-3.91-23.41Z"
            fill="url(#eYBXig1fbcm6-fill)"
          />
          <path
            style={{ mixBlendMode: "overlay" }}
            d="M133.24,192.64c-6.31-6.31-15.71-7.62-23.31-3.96-.61-4.21-2.53-8.26-5.77-11.49-3.57-3.57-8.12-5.53-12.78-5.91c2.28-19.33,12.64-39.28,26.99-54.71-4.99-3.75-4.43-5.45-4.43-5.45L33.03,192.03c30.15,30.08,73.13,39.5,111.3,28.25-2.14-1.94-4.59-3.35-7.18-4.23c3.72-7.62,2.42-17.07-3.91-23.41Z"
            opacity="0.54"
            fill="#fff"
          />
          <path d="M115.46,109.92l.05-.05c0,0-.45-.29-.05.05Z" fill="#fff" />
          <path
            d="M101.06,111.57c-12.6,6.64-26.86,10.83-40.94,11.14c3.2-7.98,1.57-17.45-4.89-23.92-4.18-4.18-9.62-6.33-15.1-6.47c1.03-6.73-1.05-13.83-6.23-19.02-1.02-1.02-2.11-1.91-3.26-2.69C40.8,59.99,41.84,43.86,33.78,32.1c-.28.28-.57.55-.85.82C10.11,55.75,-0.84,85.94,0.06,115.84c1.1,7.93,2.31,16.38,3.54,24.84c4.85,18.78,14.63,36.55,29.34,51.26.03.03.06.06.09.09l79.98-79.98c-2.01,1.3-9.79-1.61-11.94-.47l-.01-.01Z"
            fill="url(#eYBXig1fbcm9-fill)"
          />
          <path
            style={{ mixBlendMode: "multiply" }}
            d="M101.06,111.57c-12.6,6.64-26.86,10.83-40.94,11.14c3.2-7.98,1.57-17.45-4.89-23.92-4.18-4.18-9.62-6.33-15.1-6.47c1.03-6.73-1.05-13.83-6.23-19.02-1.02-1.02-2.11-1.91-3.26-2.69C40.8,59.99,41.84,43.86,33.78,32.1c-.28.28-.57.55-.85.82C10.11,55.75,-0.84,85.94,0.06,115.84c1.1,7.93,2.31,16.38,3.54,24.84c4.85,18.78,14.63,36.55,29.34,51.26.03.03.06.06.09.09l79.98-79.98c-2.01,1.3-9.79-1.61-11.94-.47l-.01-.01Z"
            opacity="0.1"
          />
          <path
            d="M108.48,106.68c-15.44,14.35-35.38,24.71-54.71,26.99-.38-4.66-2.34-9.22-5.91-12.78-3.24-3.24-7.29-5.16-11.49-5.77c3.66-7.6,2.35-17-3.96-23.31s-15.79-7.63-23.41-3.91c-.9-2.67-2.37-5.18-4.41-7.36-11.27,38.22-1.82,81.25,28.33,111.4.03.03.06.06.09.09l80.91-80.91c0,0-1.7.56-5.45-4.43l.01-.01Z"
            fill="url(#eYBXig1fbcm11-fill)"
          />
          <path
            style={{ mixBlendMode: "overlay" }}
            d="M108.48,106.68c-15.44,14.35-35.38,24.71-54.71,26.99-.38-4.66-2.34-9.22-5.91-12.78-3.24-3.24-7.29-5.16-11.49-5.77c3.66-7.6,2.35-17-3.96-23.31s-15.79-7.63-23.41-3.91c-.9-2.67-2.37-5.18-4.41-7.36-11.27,38.22-1.82,81.25,28.33,111.4.03.03.06.06.09.09l80.91-80.91c0,0-1.7.56-5.45-4.43l.01-.01Z"
            opacity="0.54"
            fill="#fff"
          />
          <path
            d="M92.31,203.82c-1.51-1.51-3.26-2.64-5.12-3.39c6.68-8.27,6.21-20.39-1.44-28.04-1.51-1.51-3.19-2.73-4.98-3.68c4.59-11.06,11.86-23.2,21.89-36.26l4.54,4.54c1.71,1.71,4.58,1.18,5.49-1.02l3.55-8.61l2.36,2.36c2.03,2.03,4.69,3.04,7.32,3.04l-4.32,31.8c-.42,3.06,3.4,4.87,5.44,2.59l20.06-22.42c4.89-5.46,6.72-13.04,4.9-20.26l-2.75-10.92l13.31-13.31c10.01-10.01,16.52-23.01,18.59-37.12l2.52-17.22c.38-2.63-1.91-4.92-4.54-4.54l-17.22,2.52c-14.11,2.07-27.11,8.57-37.12,18.59L111.48,75.78l-10.92-2.75c-7.22-1.82-14.79.02-20.26,4.9L57.88,97.99c-2.28,2.04-.46,5.86,2.59,5.44l31.8-4.32c0,2.64,1.01,5.29,3.04,7.32l2.36,2.36-8.61,3.55c-2.2.91-2.73,3.78-1.02,5.49l4.54,4.54c-13.06,10.03-25.2,17.29-36.26,21.89-.95-1.79-2.18-3.47-3.68-4.98-7.65-7.65-19.77-8.12-28.04-1.44-.75-1.87-1.88-3.61-3.39-5.12-5.35-5.35-13.65-5.91-19.69-1.76c3.71,22.32,14.18,43.74,31.4,60.96c17.29,17.29,38.81,27.77,61.23,31.44c4.06-6.03,3.46-14.25-1.85-19.55l.01.01Z"
            fill="#f2f2f2"
          />
          <path
            d="M94.16,223.38c4.06-6.03,3.46-14.25-1.85-19.55-1.51-1.51-3.26-2.64-5.12-3.39c6.68-8.27,6.21-20.39-1.44-28.04-1.51-1.51-3.19-2.73-4.98-3.68c4.59-11.06,11.86-23.2,21.89-36.26L107.2,137c1.71,1.71,4.58,1.18,5.49-1.02l3.56-8.61l2.36,2.36c2.03,2.03,4.69,3.04,7.32,3.04l-4.32,31.8c-.42,3.06,3.4,4.87,5.44,2.59l20.05-22.42c4.89-5.46,6.72-13.04,4.9-20.26l-2.75-10.92l13.31-13.31c10.01-10.01,16.52-23.01,18.59-37.12l2.52-17.22c.2-1.36-.33-2.62-1.24-3.48L33.02,192.03c17.27,17.24,38.76,27.68,61.14,31.35Z"
            fill="#e5daeb"
          />
          <path
            d="M147.1,144.73c4.89-5.46,6.72-13.04,4.9-20.26l-2.75-10.92l13.31-13.31c10.01-10.01,16.52-23.01,18.59-37.12l2.52-17.22c.19-1.29-.27-2.5-1.1-3.35l-3.2,14.09c-3.21,14.13-10.73,27.53-21.46,38.26l-14.27,14.27l1.82,10.57c1.2,6.99-1.24,14.63-6.53,20.44l-16.47,18.1-.85,6.28c-.42,3.06,3.4,4.87,5.44,2.59l20.05-22.42Z"
            fill="#fefefe"
          />
          <circle
            r="12.49"
            transform="translate(152.09 72.95)"
            fill="url(#eYBXig1fbcm16-fill)"
          />
          <g
            id="eYBXig1fbcm17_ts"
            transform="translate(77.970001,42.190001) scale(0.75,0.75)"
          >
            <path
              d="M77.97,28.05l1.29,10.18c.18,1.4,1.28,2.49,2.67,2.67l10.18,1.29-10.18,1.29c-1.4.18-2.49,1.28-2.67,2.67L77.97,56.33L76.68,46.15c-.18-1.4-1.28-2.49-2.67-2.67L63.83,42.19L74.01,40.9c1.4-.18,2.49-1.28,2.67-2.67l1.29-10.18Z"
              transform="translate(-77.970001,-42.190001)"
              fill="#fff"
            />
          </g>
          <g
            id="eYBXig1fbcm18_ts"
            transform="translate(180.5,143.169983) scale(1,1)"
          >
            <path
              d="M180.5,122.1l1.93,15.16c.26,2.08,1.9,3.71,3.98,3.98l15.16,1.93-15.16,1.93c-2.08.26-3.71,1.9-3.98,3.98l-1.93,15.16-1.93-15.16c-.26-2.08-1.9-3.71-3.98-3.98l-15.16-1.93l15.16-1.93c2.08-.26,3.71-1.9,3.98-3.98l1.93-15.16Z"
              transform="translate(-180.5,-143.169983)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>

    // <svg
    //   id="ehWrypZQTqz1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 602 600"
    //   shapeRendering="geometricPrecision"
    //   textRendering="geometricPrecision"
    // >
    //   <defs>
    //     <filter
    //       id="ehWrypZQTqz4-filter"
    //       x="-150%"
    //       width="400%"
    //       y="-150%"
    //       height="400%"
    //     >
    //       <feColorMatrix
    //         id="ehWrypZQTqz4-filter-hue-rotate-0"
    //         type="hueRotate"
    //         values="19.8"
    //         result="result"
    //       />
    //     </filter>
    //     <linearGradient
    //       id="ehWrypZQTqz4-fill"
    //       x1="0"
    //       y1="-0.000041"
    //       x2="1"
    //       y2="-0.000041"
    //       spreadMethod="pad"
    //       gradientUnits="userSpaceOnUse"
    //       gradientTransform="translate(0 0)"
    //     >
    //       <stop id="ehWrypZQTqz4-fill-0" offset="0%" stopColor="#ce4297" />
    //       <stop id="ehWrypZQTqz4-fill-1" offset="100%" stopColor="#f57d35" />
    //     </linearGradient>
    //     <filter
    //       id="ehWrypZQTqz5-filter"
    //       x="-150%"
    //       width="400%"
    //       y="-150%"
    //       height="400%"
    //     >
    //       <feColorMatrix
    //         id="ehWrypZQTqz5-filter-hue-rotate-0"
    //         type="hueRotate"
    //         values="0"
    //         result="result"
    //       />
    //     </filter>
    //     <linearGradient
    //       id="ehWrypZQTqz6-fill"
    //       x1="0"
    //       y1="0.000006"
    //       x2="1"
    //       y2="0.000006"
    //       spreadMethod="pad"
    //       gradientUnits="userSpaceOnUse"
    //       gradientTransform="translate(0 0)"
    //     >
    //       <stop id="ehWrypZQTqz6-fill-0" offset="0%" stopColor="#a927fa" />
    //       <stop id="ehWrypZQTqz6-fill-1" offset="100%" stopColor="#ce4297" />
    //     </linearGradient>
    //     <linearGradient
    //       id="ehWrypZQTqz8-fill"
    //       x1="0"
    //       y1="0.000005"
    //       x2="1"
    //       y2="0.000005"
    //       spreadMethod="pad"
    //       gradientUnits="userSpaceOnUse"
    //       gradientTransform="translate(0 0)"
    //     >
    //       <stop id="ehWrypZQTqz8-fill-0" offset="0%" stopColor="#a927fa" />
    //       <stop id="ehWrypZQTqz8-fill-1" offset="100%" stopColor="#ce4297" />
    //     </linearGradient>
    //     <filter
    //       id="ehWrypZQTqz10-filter"
    //       x="-150%"
    //       width="400%"
    //       y="-150%"
    //       height="400%"
    //     >
    //       <feColorMatrix
    //         id="ehWrypZQTqz10-filter-hue-rotate-0"
    //         type="hueRotate"
    //         values="0"
    //         result="result"
    //       />
    //     </filter>
    //   </defs>
    //   <g
    //     id="ehWrypZQTqz2_ts"
    //     transform="translate(301.001209,299.923042) scale(1,1)"
    //   >
    //     <g transform="translate(-400.001209,-299.923042)" clipRule="evenodd">
    //       <g
    //         transform="matrix(0-346.248-346.248 0 399.984 456.771)"
    //         clipRule="evenodd"
    //       >
    //         <path
    //           d="M1,0c0,.146-.057.283-.16.387-.103.103-.241.16-.387.16-.182,0-.351-.091-.453-.239c0-.001.001-.001.001-.001.022-.029.032-.065.03-.101.023-.021.038-.049.042-.081.005-.004.009-.009.013-.015h.059c.002.005.003.009.005.013l-.087.11c.012.01.025.019.039.027l.016.01c.042.03.104.045.168.041.063-.004.124-.027.172-.065.09.001.18-.021.269-.066.092-.046.159-.105.191-.136L0.964,0l-.046-.044c-.064-.062-.233-.202-.459-.202-.048-.038-.109-.061-.172-.065-.064-.004-.127.011-.169.041l-.055.037.087.11c-.002.004-.003.008-.005.013h-.059c-.004-.005-.009-.01-.013-.014-.004-.032-.019-.061-.042-.081.002-.036-.008-.072-.03-.101C0,-0.307,0,-0.307,0,-0.307c.101-.149.271-.24.453-.24.146,0,.284.057.387.16.103.104.16.241.16.387v0Z"
    //           clipRule="evenodd"
    //           filter="url(#ehWrypZQTqz4-filter)"
    //           fill="url(#ehWrypZQTqz4-fill)"
    //           strokeLinejoin="round"
    //           strokeMiterlimit="2"
    //         />
    //       </g>
    //       <g
    //         transform="matrix(0-80.9161-80.9161 0 399.915 489.756)"
    //         clipRule="evenodd"
    //         filter="url(#ehWrypZQTqz5-filter)"
    //       >
    //         <path
    //           d="M1,-0.212v.427h-.381c-.003,0-.004,0-.007,0-.004.09-.071.163-.158.176.008.026.014.054.014.084c0,.135-.094.248-.22.279.025.052.039.109.039.17c0,.051-.01.1-.028.144C0.094,0.748,0,0.384,0,-0.001s.093-.747.258-1.067c.018.045.029.094.029.146c0,.061-.014.118-.039.17.126.031.22.144.22.279c0,.03-.006.058-.014.085.087.013.154.085.158.175.003,0,.004.001.007.001h.381Z"
    //           clipRule="evenodd"
    //           fill="url(#ehWrypZQTqz6-fill)"
    //           strokeLinejoin="round"
    //           strokeMiterlimit="2"
    //         />
    //       </g>
    //       <g
    //         transform="matrix(0-600.006-600.006 0 400.001 600.001)"
    //         clipRule="evenodd"
    //       >
    //         <g id="ehWrypZQTqz8_tr" transform="translate(0.500125,0) rotate(0)">
    //           <path
    //             d="M0.993,0.085L0.896,0.1l-.003.011c-.009.031-.021.06-.037.088l-.006.01.058.08c-.016.023-.034.045-.054.065s-.042.038-.065.054l-.08-.058-.01.006c-.028.016-.057.028-.088.037L0.6,0.396l-.015.097c-.028.005-.057.007-.085.007s-.057-.002-.085-.007L0.4,0.396l-.011-.003c-.031-.009-.06-.021-.088-.037l-.01-.006-.08.058c-.023-.016-.045-.034-.065-.054-.019-.02-.038-.042-.054-.065l.058-.08-.007-.011c-.003-.006-.006-.013-.01-.019c0,0,0,0,0,0-.005-.01-.009-.021-.013-.031-.001-.002-.002-.005-.003-.007-.003-.01-.007-.02-.01-.03L0.104,0.1l-.097-.015c-.009-.056-.009-.114,0-.17l.097-.015.003-.011c.004-.011.007-.021.011-.032.001-.001.001-.002.001-.003.005-.011.009-.022.014-.033c0,0,0,0,0,0l.011-.02.006-.01-.058-.08c.016-.023.035-.045.054-.065.02-.019.042-.038.065-.054l.08.058.01-.006c.028-.016.057-.028.088-.037l.011-.003.015-.097c.028-.005.057-.007.085-.007s.057.002.085.007l.015.097.011.003c.031.009.06.021.088.037l.01.006.08-.058c.023.016.045.034.065.054s.038.042.054.065l-.058.08.006.01c.016.028.028.057.037.088l.003.011.097.015c.005.028.007.057.007.085s-.002.057-.007.085Zm-.142-.086v0c0-.093-.036-.181-.102-.247-.067-.067-.155-.103-.249-.103h-.022c-.184.012-.33.164-.33.351s.146.339.33.351h.022c.094,0,.182-.036.249-.103.066-.066.102-.154.102-.247v0-.001c0,0,0,0,0,0s0-.001,0-.001Z"
    //             transform="translate(-0.500125,0)"
    //             clipRule="evenodd"
    //             fill="url(#ehWrypZQTqz8-fill)"
    //             strokeLinejoin="round"
    //             strokeMiterlimit="2"
    //           />
    //         </g>
    //       </g>
    //       <g
    //         transform="matrix(8.56881 0 0 8.56881 430.434 291.017)"
    //         clipRule="evenodd"
    //       >
    //         <path
    //           d="M0,-2.844c-.411-1.585-1.838-2.761-3.552-2.761-1.713,0-3.141,1.176-3.552,2.761-.077-.296-.13-.602-.13-.922c0-2.034,1.648-3.682,3.682-3.682s3.683,1.648,3.683,3.682c0,.32-.054.626-.131.922M3.852,1.673c.414-8.822-5.398-15.611-7.407-17.683-1.097,1.127-3.323,3.647-5.05,7.102-1.776,3.551-2.567,7.098-2.381,10.609-3.447,3.724-3.085,9.092-1.436,11.465l3.866-3.068c.55.721,1.341,1.153,2.187,1.153h5.63c.846,0,1.636-.432,2.187-1.152l3.864,3.067c1.654-2.378,2.015-7.768-1.46-11.493"
    //           clipRule="evenodd"
    //           filter="url(#ehWrypZQTqz10-filter)"
    //           fill="#a927fa"
    //           strokeLinejoin="round"
    //           strokeMiterlimit="2"
    //         />
    //       </g>
    //     </g>
    //   </g>
    // </svg>
  );
};
export default LogoIcon;
